import { FC } from 'react';
import { MessageMediumTab } from 'modules/intelligentInsights/frequencyOptimization/types';
import { useManagementSettingsContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/ManagementSettingsContext';
import { BreakdownMessageTypeLoading } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/messageType/BreakdownMessageTypeLoading';
import { BreakdownMessageTypeTable } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/messageType/BreakdownMessageTypeTable';
import { BreakdownByMessageTypeWrapper } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/audienceLift/BreakdownAudienceLift.styles';

export type BreakdownMessageTypeProps = {
  messageMedium: MessageMediumTab;
};

export const BreakdownMessageTypes: FC<BreakdownMessageTypeProps> = ({ messageMedium }) => {
  const { frmManagementSettings, isLoading } = useManagementSettingsContext();

  if (isLoading) {
    return <BreakdownMessageTypeLoading />;
  }

  return (
    <BreakdownByMessageTypeWrapper>
      <BreakdownMessageTypeTable
        frmSettings={frmManagementSettings}
        messageMedium={messageMedium}
      />
    </BreakdownByMessageTypeWrapper>
  );
};
